import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetNicePayConfig200,
  GetNicePayConfig500,
  NicePayBillingCallback200,
  NicePayBillingCallbackBody,
  NicePayPaymentCallback200,
  NicePayPaymentCallbackBody,
  NicePayReturn200,
  NicePayReturnParams
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * NicePay 결제에 필요한 설정 정보를 조회합니다
 * @summary NicePay 설정 조회
 */
export const getNicePayConfig = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetNicePayConfig200>(
      {url: `/api/v1/payment-methods/nicepay/config`, method: 'GET', signal
    },
      options);
    }
  

export const getGetNicePayConfigQueryKey = () => {
    return [`/api/v1/payment-methods/nicepay/config`] as const;
    }

    
export const getGetNicePayConfigInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getNicePayConfig>>, TError = GetNicePayConfig500>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNicePayConfig>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNicePayConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNicePayConfig>>> = ({ signal }) => getNicePayConfig(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNicePayConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNicePayConfigInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNicePayConfig>>>
export type GetNicePayConfigInfiniteQueryError = GetNicePayConfig500

/**
 * @summary NicePay 설정 조회
 */
export const useGetNicePayConfigInfinite = <TData = Awaited<ReturnType<typeof getNicePayConfig>>, TError = GetNicePayConfig500>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNicePayConfig>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNicePayConfigInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNicePayConfigQueryOptions = <TData = Awaited<ReturnType<typeof getNicePayConfig>>, TError = GetNicePayConfig500>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNicePayConfig>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNicePayConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNicePayConfig>>> = ({ signal }) => getNicePayConfig(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNicePayConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNicePayConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getNicePayConfig>>>
export type GetNicePayConfigQueryError = GetNicePayConfig500

/**
 * @summary NicePay 설정 조회
 */
export const useGetNicePayConfig = <TData = Awaited<ReturnType<typeof getNicePayConfig>>, TError = GetNicePayConfig500>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNicePayConfig>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNicePayConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * NicePay에서 빌링키 등록 결과를 받는 콜백입니다
 * @summary NicePay 빌링 콜백
 */
export const nicePayBillingCallback = (
    nicePayBillingCallbackBody: NicePayBillingCallbackBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<NicePayBillingCallback200>(
      {url: `/api/v1/payment-methods/nicepay/billing/callback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: nicePayBillingCallbackBody
    },
      options);
    }
  


export const getNicePayBillingCallbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof nicePayBillingCallback>>, TError,{data: NicePayBillingCallbackBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof nicePayBillingCallback>>, TError,{data: NicePayBillingCallbackBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof nicePayBillingCallback>>, {data: NicePayBillingCallbackBody}> = (props) => {
          const {data} = props ?? {};

          return  nicePayBillingCallback(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NicePayBillingCallbackMutationResult = NonNullable<Awaited<ReturnType<typeof nicePayBillingCallback>>>
    export type NicePayBillingCallbackMutationBody = NicePayBillingCallbackBody
    export type NicePayBillingCallbackMutationError = unknown

    /**
 * @summary NicePay 빌링 콜백
 */
export const useNicePayBillingCallback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof nicePayBillingCallback>>, TError,{data: NicePayBillingCallbackBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof nicePayBillingCallback>>,
        TError,
        {data: NicePayBillingCallbackBody},
        TContext
      > => {

      const mutationOptions = getNicePayBillingCallbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * NicePay에서 결제 결과를 받는 콜백입니다
 * @summary NicePay 결제 콜백
 */
export const nicePayPaymentCallback = (
    nicePayPaymentCallbackBody: NicePayPaymentCallbackBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<NicePayPaymentCallback200>(
      {url: `/api/v1/payment-methods/nicepay/payment/callback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: nicePayPaymentCallbackBody
    },
      options);
    }
  


export const getNicePayPaymentCallbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof nicePayPaymentCallback>>, TError,{data: NicePayPaymentCallbackBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof nicePayPaymentCallback>>, TError,{data: NicePayPaymentCallbackBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof nicePayPaymentCallback>>, {data: NicePayPaymentCallbackBody}> = (props) => {
          const {data} = props ?? {};

          return  nicePayPaymentCallback(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NicePayPaymentCallbackMutationResult = NonNullable<Awaited<ReturnType<typeof nicePayPaymentCallback>>>
    export type NicePayPaymentCallbackMutationBody = NicePayPaymentCallbackBody
    export type NicePayPaymentCallbackMutationError = unknown

    /**
 * @summary NicePay 결제 콜백
 */
export const useNicePayPaymentCallback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof nicePayPaymentCallback>>, TError,{data: NicePayPaymentCallbackBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof nicePayPaymentCallback>>,
        TError,
        {data: NicePayPaymentCallbackBody},
        TContext
      > => {

      const mutationOptions = getNicePayPaymentCallbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * NicePay 결제 완료 후 리턴되는 페이지입니다
 * @summary NicePay 리턴 페이지
 */
export const nicePayReturn = (
    params?: NicePayReturnParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NicePayReturn200>(
      {url: `/api/v1/payment-methods/nicepay/return`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getNicePayReturnQueryKey = (params?: NicePayReturnParams,) => {
    return [`/api/v1/payment-methods/nicepay/return`, ...(params ? [params]: [])] as const;
    }

    
export const getNicePayReturnInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof nicePayReturn>>, TError = unknown>(params?: NicePayReturnParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof nicePayReturn>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNicePayReturnQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof nicePayReturn>>> = ({ signal }) => nicePayReturn(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof nicePayReturn>>, TError, TData> & { queryKey: QueryKey }
}

export type NicePayReturnInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof nicePayReturn>>>
export type NicePayReturnInfiniteQueryError = unknown

/**
 * @summary NicePay 리턴 페이지
 */
export const useNicePayReturnInfinite = <TData = Awaited<ReturnType<typeof nicePayReturn>>, TError = unknown>(
 params?: NicePayReturnParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof nicePayReturn>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNicePayReturnInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNicePayReturnQueryOptions = <TData = Awaited<ReturnType<typeof nicePayReturn>>, TError = unknown>(params?: NicePayReturnParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof nicePayReturn>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNicePayReturnQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof nicePayReturn>>> = ({ signal }) => nicePayReturn(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof nicePayReturn>>, TError, TData> & { queryKey: QueryKey }
}

export type NicePayReturnQueryResult = NonNullable<Awaited<ReturnType<typeof nicePayReturn>>>
export type NicePayReturnQueryError = unknown

/**
 * @summary NicePay 리턴 페이지
 */
export const useNicePayReturn = <TData = Awaited<ReturnType<typeof nicePayReturn>>, TError = unknown>(
 params?: NicePayReturnParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof nicePayReturn>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNicePayReturnQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



